import React from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'

const SupportSubmissionModal = ({ isOpen, toggle, error }) => {
  // Generate unique IDs for accessibility
  const modalId = 'support-submission-modal'
  const modalTitleId = 'support-submission-title'

  // Determine message ID based on error state
  const messageId = error ? 'error.support.submission' : 'success.support.submission'
  const statusType = error ? 'error' : 'success'

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      centered
      id={modalId}
      aria-labelledby={modalTitleId}
      role="dialog"
    >
      <ModalHeader toggle={toggle}>
        <span className="sr-only">
          <FormattedMessage
            id="global.label.close"
            defaultMessage={`Close ${statusType} message`}
          />
        </span>
      </ModalHeader>
      <ModalBody>
        <h2 id={modalTitleId} className="text-center">
          <FormattedMessage id="page.supportPage.title.heroTitle" />
        </h2>
        <p aria-live="polite">
          <FormattedMessage id={messageId} />
        </p>
      </ModalBody>
      <ModalFooter>
        <div className="w-100">
          <div className="row">
            <div className="col">
              <Button
                block
                outline
                color={error ? 'danger' : 'light'}
                onClick={toggle}
                aria-label={`Close ${statusType} message`}
              >
                <FormattedMessage id="global.label.popoverClose" />
              </Button>
            </div>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  )
}

SupportSubmissionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  error: PropTypes.bool,
}

SupportSubmissionModal.defaultProps = {
  error: false,
}

export default SupportSubmissionModal
